import { Dayjs } from 'dayjs';
import React from 'react';
import { ReactComponent as HappyFace } from '../../assets/svg/happy_face.svg';
import { ReactComponent as NeutralFace } from '../../assets/svg/neutral_face.svg';
import { ReactComponent as SadFace } from '../../assets/svg/sad_face.svg';

export function CourierRatingDetails({
  positiveRatingsCount,
  neutralRatingsCount,
  negativeRatingsCount,
  comments,
  startTime,
  endTime,
  deliveriesCount,
}: {
  positiveRatingsCount: number;
  neutralRatingsCount: number;
  negativeRatingsCount: number;
  comments: string[];
  startTime: Dayjs;
  endTime: Dayjs;
  deliveriesCount: number;
}): JSX.Element {
  const ratingsCount =
    negativeRatingsCount + positiveRatingsCount + neutralRatingsCount;
  const totalTimeMinutes = endTime.diff(startTime, 'minute');
  const deliveriesPerHour =
    totalTimeMinutes > 0
      ? ((deliveriesCount * 60) / totalTimeMinutes).toFixed(0)
      : 0;

  return (
    <div>
      <p className="rating-count">{ratingsCount} rating(s)</p>
      <div className="rating-faces">
        <div>
          <SadFace />
          <p>{negativeRatingsCount}</p>
        </div>
        <div>
          <NeutralFace />
          <p>{neutralRatingsCount}</p>
        </div>
        <div>
          <HappyFace />
          <p>{positiveRatingsCount}</p>
        </div>
      </div>
      <div className="rating-comments">
        {comments.map((comment, index) => (
          <p key={index}>"{comment}"</p>
        ))}
      </div>
      <div className="rating-table">
        <div>
          <span>Start:</span>
          <span>{startTime.format('HH:mm')}</span>
        </div>
        <div>
          <span>End:</span>
          <span>{endTime.format('HH:mm')}</span>
        </div>
        <div>
          <span>Total time:</span>
          <span>
            {Math.floor(totalTimeMinutes / 60)} h {totalTimeMinutes % 60} min
          </span>
        </div>
        <div>
          <span>Deliveries:</span>
          <span>{deliveriesCount}</span>
        </div>
        <div>
          <span>Deliveries per hour:</span>
          <span>{deliveriesPerHour}</span>
        </div>
      </div>
    </div>
  );
}
